<template>
  <div class="hzc-industry-dynamics">
    <div class="back">当前位置：<span @click="back">焦炭</span> > 价格</div>
    <div class="content">
      <div class="header">
        <em></em>
        <p>价格</p>
        <div class="btn fr">搜索</div>
        <input class="fr" type="text" placeholder="请输入关键词">
      </div>
      <div class="tabs">
        <div @click="changeTabs('issue_coke_place_price')" :class="{'hover':flag === 'issue_coke_place_price'}">产地价格</div>
        <div @click="changeTabs('issue_coke_port_price')" :class="{'hover':flag === 'issue_coke_port_price'}">港口价格</div>
        <div @click="changeTabs('issue_coke_exit_price')" :class="{'hover':flag === 'issue_coke_exit_price'}">进出口价格</div>
      </div>
      <ul>
        <li v-for="(item,index) in list" :key="index">
          <img src="../../../assets/home/liebiaoqian.png" alt="">
          <p @click="goDetail(item.completeOriginalDate, flag)">{{ item.date + (flag === 'issue_coke_place_price' ? '焦炭产地价格' : flag === 'issue_coke_port_price' ? '焦炭港口价格' :'焦炭进出口价格') }}</p>
          <span class="fr">{{ item.completeOriginalDate }}</span>
          <em v-if="(index+1)%5 === 0 && (index+1) !== list.length" class="xiaxuxian"></em>
        </li>
      </ul>
    </div>
    <div style="text-align: center;">
      <span
          style="vertical-align:middle;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
          @click="homePage">首页</span>
      <el-pagination
          style="margin: 24px 0;display: inline-block;vertical-align:middle;"
          background
          prev-text="上一页"
          next-text="下一页"
          :page-size="size"
          :current-page="page"
          @current-change="changePage"
          layout="prev, pager, next,slot, total,jumper"
          :total="total">
        <span
            style="margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
            @click="lastPage">末页</span>
      </el-pagination>
      <span
          style="margin-left:20px;color:#FFF;background-color:#D3131A;margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;font-weight: normal;cursor: pointer;">跳转</span>
    </div>
  </div>
</template>

<script>
import {
  pricePage,
} from '@/api/coke'

export default {
  data() {
    return {
      list: [],
      page: 1,
      size: 15,
      total: 0,
      flag: 'issue_coke_place_price'
    }
  },
  created() {
    if (this.$route.query&&this.$route.query['flag']) {
      this.flag = this.$route.query['flag'];
    }
    this.getList({pageNum: this.page, pageSize: this.size, dictDataType: this.flag, dataType: 1});
  },
  methods: {
    // 列表
    getList(pageParams) {
      pricePage(pageParams).then(res => {
        this.list = res.rows;
        this.total = res.total;
      })
    },
    /**
     * 切换tabs
     */
    changeTabs(num) {
      this.flag = num;
      this.page = 1;
      this.getList({pageNum: this.page, pageSize: this.size, dictDataType: this.flag, dataType: 1});
    },
    /**
     * 前往详情页
     */
    goDetail(id, flag) {
      this.$router.push({path:`/coke/priceIndex`, query:{id,flag}})
    },
    /**
     * 回退
     */
    back() {
      this.$router.push('/coke')
    },
    /**
     * 分页
     */
    changePage(page) {
      this.page = page;
      this.getList({pageNum: this.page, pageSize: this.size, dictDataType: this.flag, dataType: 1})
    },
    /**
     * 首页
     */
    homePage(){
      this.changePage(1)
    },
    /**
     * 末页
     */
    lastPage(){
      let cpage = Math.ceil(this.total / this.size);
      this.changePage(cpage)
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../style/twoPage";
</style>
